
export const SET_NAVEGATION_STEPS = "SET_NAVEGATION_STEPS"
export const LOADING_NAVEGATION_STEPS = "LOADING_NAVEGATION_STEPS"
export const SET_ERROR_NAVEGATION_STEPS = "SET_ERROR_NAVEGATION_STEPS"
export const SET_CURRENT_NAVEGATION_STEPS = "SET_CURRENT_NAVEGATION_STEPS"
export const SET_CURRENT_STEP = "SET_CURRENT_STEP"
export const SET_VALIDATE_FIELDS = "SET_VALIDATE_FIELDS"
export const SET_IS_VALID_FIELDS = "SET_IS_VALID_FIELDS"